"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDateFormat = exports.isValid = void 0;
var isValid = function (date) {
    if (!isNaN(date) && date instanceof Date)
        return date;
    return null;
};
exports.isValid = isValid;
var toDateFormat = function (date) {
    return exports.isValid(new Date(date));
};
exports.toDateFormat = toDateFormat;
exports.toDateFormat.numeric = function (date) {
    if (date === null)
        return;
    var fmtl = new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    return fmtl.format(exports.toDateFormat(date));
};
exports.toDateFormat.shortMonth = function (date) {
    if (date === null)
        return;
    var fmtl = new Intl.DateTimeFormat('en', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    return fmtl.format(exports.toDateFormat(date));
};
exports.toDateFormat.startOfDay = function (date) {
    var startOfDay = new Date(date).setHours(0, 0, 0, 0);
    return exports.isValid(new Date(startOfDay));
};
exports.toDateFormat.endOfDay = function (date) {
    var endOfDay = new Date(date).setHours(23, 59, 59, 999);
    return exports.isValid(new Date(endOfDay));
};
//# sourceMappingURL=dateFormat.js.map